import {
  validatePresence,
  validateNumber,
} from 'ember-changeset-validations/validators';

export default {
  transDate: validatePresence({
    presence: true,
    message: "Date can't be blank",
  }),
  transType: validatePresence({
    presence: true,
    message: "Type can't be blank",
  }),
  amount: validateNumber(),
};
